import React, { useEffect, useState } from "react";
import { api, mediaSrc, mediaSrcById } from "../api";
import { useApp } from "../context/AppContext";

const variantCache = new Map(); // `${mediaId}|${lang}` → media id in that language

/** Pack stickers carry captions per language: always show the variant in the VIEWER's language. */
export function LocalizedSticker({ media, className, testid = "message-sticker" }) {
  const { lang } = useApp();
  const needs = !!media?.sticker_key && media?.sticker_lang && media.sticker_lang !== lang;
  const key = `${media?.id}|${lang}`;
  const [id, setId] = useState(needs ? variantCache.get(key) || null : media?.id);

  useEffect(() => {
    if (!needs) { setId(media?.id); return undefined; }
    if (variantCache.has(key)) { setId(variantCache.get(key)); return undefined; }
    let alive = true;
    api.get(`/stickers/variant/${media.id}`, { params: { lang } })
      .then((r) => { const v = r.data?.id || media.id; variantCache.set(key, v); if (alive) setId(v); })
      .catch(() => { if (alive) setId(media.id); });
    return () => { alive = false; };
  }, [media?.id, lang, needs, key]);

  if (!media) return null;
  const src = id && id !== media.id ? mediaSrcById(id) : mediaSrc(media);
  return <img src={src} alt="" loading="lazy" draggable={false} className={className} data-testid={testid} data-sticker-lang={id === media.id ? media.sticker_lang || "" : lang} />;
}
